<ng-template #loading >
  <div class="d-flex justify-content-center align-items-center h-100 w-100 pt-4">
    <mat-spinner class="mt-4 loading-spinner"></mat-spinner>
  </div>
</ng-template>

<ng-container *ngIf="!(loading$ | async) && proposalId === (proposalTile$|async).id && (proposalTile$|async) as proposalTile; else loading">
  <ng-container
    *ngIf="{current: (selectedTab$|async)?.[1] , previous:(selectedTab$|async)?.[0]} as selectedTab;">
    <div id="proposal-details-header" class="header-container" *ngIf="currentHeader != Header.none "
         [style]="'width: '+tabBar.getBoundingClientRect().width + 'px;'">
      <div class="header-inner-container w-100">
        <div #header *ngIf="currentHeader >= Header.title ">
          <ng-container *ngTemplateOutlet="titleHeader"></ng-container>
        </div>
        <ng-container *ngIf="currentHeader >= Header.tabs">
          <hr class="mb-0">
          <ng-container *ngTemplateOutlet="tabBarTemplate"></ng-container>
        </ng-container>
        <hr class="mb-0">
      </div>

    </div>
    <div id="proposal-details-body" class="d-flex flex-column vh-100">
      <ng-scrollbar visibility="hover">
        <div
          class="pt-3 d-flex min-vh-100 flex-column h-100 top-main-container">
          <a [href]="Route.INSERATE" class="back">
            <mat-icon>arrow_backward</mat-icon>
            {{'nav.back' | translate}}</a>
          <div #title>
            <ng-container *ngTemplateOutlet="titleTemplate"></ng-container>
          </div>
          <div class="d-flex flex-shrink-1 flex-row main-container">


            <div id="proposal-details-tabs"
                 class=" d-flex flex-column flex-grow-1 flex-shrink-1 left-container">

              <app-proposal-tile [detailsTile]="true" [proposalTile]="proposalTile"
                                 class="w-100">
                <div #createOfferButton>
                  <ng-container *ngTemplateOutlet="createOfferButtonTemplate"></ng-container>
                </div>
              </app-proposal-tile>
              <hr>
              <div #tabBar>
                <ng-container *ngTemplateOutlet="tabBarTemplate"></ng-container>
                <hr class="mb-0 mt-3">
              </div>
              <div class="w-100 h-100 body-container mt-4">
                <div *ngIf="hasPermission(Tab.DETAILS)"
                     [class.selected]="(selectedTab?.current) === Tab.DETAILS"
                     [class.previously-selected]="(selectedTab.previous)=== Tab.DETAILS"
                     class="overflow-hidden"
                     label="Details">
                  <app-proposal-details-expandable
                    [(allDetailsOpen)]="allDetailsOpen"></app-proposal-details-expandable>
                </div>
                <div
                  *ngIf=" hasPermission(Tab.OFFERS) && (proposalTile$|async) as proposalTile "
                  [class.selected]="(selectedTab?.current) === Tab.OFFERS"
                  [class.previously-selected]="(selectedTab?.previous)=== Tab.OFFERS"
                  class="overflow-hidden"
                  label="Offers">
                  <app-offers-list-tab [proposalTile]="proposalTile"
                                       class="d-flex flex-column w-100"></app-offers-list-tab>
                </div>
                <div *ngIf="hasPermission(Tab.LEADING_OFFER) && (hasLeadingOfferInfo$|async) && ((hasCreatedOfferForThisProposal$|async) || (isProposalCreator$|async) || (isRepresentativeForProposalCreator|async)) && (proposal$|async) as proposal"
                     [class.selected]="(selectedTab?.current)==Tab.LEADING_OFFER"
                     [class.previously-selected]="(selectedTab.previous)=== Tab.LEADING_OFFER"
                     class="overflow-hidden"
                     label="Leading Offer">
                    <app-leading-offer-tab [leadingOfferInfo]="proposal?.leadingOfferInfo" class="w-100"></app-leading-offer-tab>
                </div>
                <div label="Offers" class="w-100 d-flex"
                     *ngIf=" hasPermission(Tab.SLIP) && (hasAcceptedOffers$|async) && (proposal$|async) as proposal"
                     [class.selected]="(selectedTab?.current) === Tab.SLIP"
                     [class.previously-selected]="(selectedTab?.previous)=== Tab.SLIP">
                  <app-proposal-slip-tab class="proposal-slip-tab mb-3 w-100" [proposal]="proposal"></app-proposal-slip-tab>
                </div>
                <div *ngIf="hasPermission(Tab.VERSION_HISTORY)"
                     [class.selected]="(selectedTab?.current) === Tab.VERSION_HISTORY"
                     [class.previously-selected]="(selectedTab.previous)=== Tab.VERSION_HISTORY"
                     class="overflow-hidden"
                     label="Version History">
                  <app-proposal-version-history *ngIf="(selectedTab?.current) === Tab.VERSION_HISTORY"
                                                [proposalId]="proposalId"></app-proposal-version-history>
                </div>
              </div>
            </div>
          </div>


        </div>
      </ng-scrollbar>

      <ng-template #tabBarTemplate>
        <div class="tabBar d-flex gap-4 z-index-4">
          <button (click)="changeTab(Tab.DETAILS) "
                  *ngIf="hasPermission(Tab.DETAILS)"
                  [class.selected]="(selectedTab?.current)==Tab.DETAILS"
                  class="detail-page-tab-button">
            {{'proposalDetails.general' | translate}}
          </button>
          <button (click)="changeTab(Tab.OFFERS)"
                  *ngIf="hasPermission(Tab.OFFERS)"
                  [class.selected]="(selectedTab?.current)==Tab.OFFERS"
                  class="detail-page-tab-button">
            {{'proposalDetails.offers' | translate}}
          </button>
          <button (click)="changeTab(Tab.LEADING_OFFER) "
                  *ngIf="hasPermission(Tab.LEADING_OFFER) && (hasLeadingOfferInfo$ | async) && ((hasCreatedOfferForThisProposal$|async) || (isProposalCreator$|async) || (isRepresentativeForProposalCreator|async))"
                  [class.selected]="(selectedTab?.current)==Tab.LEADING_OFFER"
                  class="detail-page-tab-button">
            {{'proposalDetails.leadingOffer' | translate}}
          </button>
          <button (click)="changeTab(Tab.SLIP) "
                  *ngIf="hasPermission(Tab.SLIP) && (hasAcceptedOffers$|async)"
                  [class.selected]="(selectedTab?.current)==Tab.SLIP"
                  class="detail-page-tab-button">
            {{'proposalDetails.slip' | translate}}
          </button>
          <button (click)="changeTab(Tab.VERSION_HISTORY)"
                  *ngIf="hasPermission(Tab.VERSION_HISTORY)"
                  [class.selected]="(selectedTab?.current)==Tab.VERSION_HISTORY"
                  class="detail-page-tab-button">
            {{'proposalDetails.versionHistory' | translate}}
          </button>

        </div>
      </ng-template>
      <ng-template #titleHeader>
        <div class="d-flex justify-content-between title-header">
          <ng-container *ngTemplateOutlet="titleTemplate"></ng-container>
          <ng-container *ngIf="currentHeader >= Header.createOffer">
            <ng-container *ngTemplateOutlet="createOfferButtonTemplate"></ng-container>
          </ng-container>
        </div>
      </ng-template>


      <ng-template #createOfferButtonTemplate>
        <button class="tile-button cursor-pointer blue-content detail-create-offer"
                *ngIf="permissionService.canCreateOfferForProposal(proposalTile.coverage, proposalTile.deadline) && !(rejectedProposal$|async) && ((proposalTile$|async).userId != activeUserId) && ((user$ | async).type == Roles.ROLE_INSURER || (user$ | async).type == Roles.ROLE_UNDERWRITER  || (user$ | async).type == Roles.ROLE_BROKER) && (proposalTile.usersAllowedToView.length === 0 || proposalTile.usersAllowedToView.includes((this.user$ | async).id))"
                (click)="navigateToCreateOffer(proposalTile.id)">
          <span class="cursor-pointer">
            {{'createOffer2'|translate}}
          </span>
          <mat-icon>arrow_forward</mat-icon>
        </button>
      </ng-template>
      <ng-template #titleTemplate>
        <div class="create-offer-title">{{'proposalDetails.title' | translate}}
          #{{proposalTile.id.slice(0, 8)}}
          <ng-container *ngIf="(proposal$|async)?.partner.name as partnerName"> - {{partnerName}}</ng-container>
        </div>
      </ng-template>
    </div>
  </ng-container>

</ng-container>
